<template>
  <Layout :backToRoute="true">
    <p class="display-1 primary--text font-weight-bold">
      <v-icon class="pr-2 mb-2" size="x-large" color="primary">person</v-icon>
      {{ $t("user.title") }}
    </p>
    <div class="mt-5 mx-2 pb-12" v-if="userData.userData != null">
      <Input
        :inputTitle="$t('form.tag_id')"
        :disabled="true"
        key_index="tag_id"
      />
      <Input
        :inputTitle="$t('form.locator')"
        :disabled="true"
        key_index="locator"
      />
      <Input
        :inputTitle="$t('form.email')"
        :disabled="true"
        key_index="email"
      />
      <Input
        :inputTitle="$t('form.document')"
        :disabled="true"
        key_index="document"
      />
      <Input
        :inputTitle="$t('form.name')"
        :disabled="!editable || !editing"
        key_index="name"
      />
      <Input
        :inputTitle="$t('form.surname')"
        :disabled="!editable || !editing"
        key_index="surname"
      />
      <Input
        :inputTitle="$t('form.phone_number')"
        :disabled="!editable || !editing"
        key_index="phoneNumber"
        type="number"
      />
      <Input
        :inputTitle="$t('form.birthdate')"
        :disabled="!editable || !editing"
        key_index="birthday"
        type="date"
      />
      <Input
        :inputTitle="$t('form.gender')"
        :disabled="!editable || !editing"
        key_index="gender"
        type="select"
      />
      <Input
        :inputTitle="$t('form.country')"
        :disabled="!editable || !editing"
        key_index="country"
      />
    </div>
    <div v-if="editable" class="btn-sticky">
      <v-btn
        v-if="!editing"
        fab
        color="primary"
        elevation="0"
        class="textOverSecondary--text"
        @click="editData()"
      >
        <v-icon color="secondary"> edit </v-icon>
      </v-btn>
      <v-btn
        v-else
        fab
        color="primary"
        elevation="0"
        class="textOverSecondary--text"
        :loading="loading"
        @click="saveData()"
      >
        <v-icon color="secondary"> save </v-icon>
      </v-btn>
    </div>
  </Layout>
</template>
<script>
import { mapState } from "vuex";
import Layout from "@/views/layouts/MainLayout";
import RedirectHandler from "@/mixins/RedirectHandler";
import errorManager from "../services/error.manager";
import RequestMixin from "@/mixins/Requests";
import Input from "@/components/form-elements/InputCustom";
import { RequestService } from "../services/request.service";
const requestService = new RequestService();

export default {
  props: ["auth", "routeNames"],
  data() {
    return {
      editable: false,
      editing: false,
      loading: false,
    };
  },
  components: {
    Layout,
    Input,
  },
  mixins: [RequestMixin, RedirectHandler],
  methods: {
    editData() {
      this.editing = true;
    },
    saveData() {
      this.loading = true;
      const context = this;
      requestService
        .editUserData(context, this.userData.editData)
        .then(async () => {
          await requestService.getUserData(context).then(() => {
            this.loading = false;
            this.$store.commit("resetEditData");
          });
          this.successSaveData();
          this.editing = false;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        });
    },
    successSaveData() {
      const action = "save-user-data";
      const viewData = {
        title: {
          vicon: "person",
          text: "user.title",
        },
        primary_text: {
          vicon: "check_circle",
          text: "user.success_response.primary_text",
        },
      };
      this.successRedirect(action, viewData);
    },
  },
  computed: {
    ...mapState(["userData"]),
  },
  beforeMount() {
    requestService.getUserData(this).then(() => {
      this.$store.commit("resetEditData");
    });
  },
  created() {
    this.getUserData();
    this.$store.dispatch("getEditProfile", this).then((editable) => {
      this.editable = editable;
    });
  },
  beforeDestroy() {
    requestService.getUserData(this).then(() => {
      this.$store.commit("resetEditData");
    });
  },
};
</script>
<style lang="css">
.btn-sticky {
  position: fixed;
  right: 30px;
  bottom: 75px;
  z-index: 1;
  max-width: 500px;
}
.display-1 i {
  font-size: 33px !important;
}
@media (min-width: 500px) {
  .btn-sticky {
    right: calc(50% - 220px);
  }
}
</style>
